<script setup lang="ts">
const { siteOptions } = useSiteOptions();
</script>

<template>
  <div v-if="siteOptions" class="space-y-4">
    <div class="flex flex-col gap-1 text-lg">
      <div class="font-semibold text-primary">
        {{ siteOptions.name }}
      </div>
      <address class="not-italic" v-html="siteOptions.contact.address" />
      <a :href="`tel:${siteOptions.contact.phone.number}`">
        {{ siteOptions.contact.phone.national.replace('5389', 'JEUX (5389)') }}
      </a>
    </div>
    <UiSocialMedias :items="siteOptions.contact.social_medias" />
  </div>
</template>
